import { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Row, Col, CardHeader, CardBody, Form, FormGroup, Label, Input } from 'reactstrap';
import { H4 } from 'AbstractElements';
import { useSelector } from 'react-redux';
import ActivityLogs from './ActivityLogs'

const EditMyProfile = () => {
  const { register, handleSubmit, formState: { errors } } = useForm();
  const onEditSubmit = (data) => alert('Form is Submitted');
  const userDetail = useSelector(state => state.User.detail);
  const [detail, setDetail] = useState({});

  const activityData = userDetail?.['user_activity']?.['data_3']
    ? JSON.parse(userDetail['user_activity']['data_3'])
    : null;

  useEffect(() => {
    setDetail(userDetail);
  }, [userDetail]);

  return (
    <Form className="card" onSubmit={handleSubmit(onEditSubmit)}>
      <CardHeader className="pb-0">
        <H4 attrH4={{ className: 'card-title mb-0' }}>User Profile</H4>
      </CardHeader>
      <CardBody>
        <Row>
          <Col md="5">
            <FormGroup className="mb-3">
              <Label className="form-label"><b>Kode Referal</b></Label>
              <Input readOnly className="form-control" defaultValue={detail.referral_code} />
            </FormGroup>
          </Col>
          <Col sm="6" md="3">
            <FormGroup>
              <Label className="form-label"><b>Username</b></Label>
              <Input readOnly className="form-control" defaultValue={detail.username} />
            </FormGroup>
          </Col>
          <Col sm="6" md="4">
            <FormGroup>
              <Label className="form-label"><b>EmailAddress</b></Label>
              <Input readOnly className="form-control" defaultValue={detail.email} />
            </FormGroup>
          </Col>
          <Col md="12">
            <FormGroup>
              <Label className="form-label"><b>Address</b></Label>
              <Input readOnly className="form-control" defaultValue={detail.address} />
            </FormGroup>
          </Col>
        </Row>
        <ActivityLogs logs={activityData?.logCourseNextButton} />
      </CardBody>
    </Form>
  );
};
export default EditMyProfile;